module.exports = __webpack_public_path__ + "static/img/storeDown.34f7b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/storeDown.png
// module id = Ae/S
// module chunks = 0